// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1wOCv","containerItemsCenter":"Skeleton_containerItemsCenter__2c5xn"};